var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('audio',{ref:"audioElm",attrs:{"src":_vm.audioSrc,"controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }